import { render, staticRenderFns } from "./time-line.vue?vue&type=template&id=ff6bf78a&scoped=true&"
import script from "./time-line.vue?vue&type=script&lang=js&"
export * from "./time-line.vue?vue&type=script&lang=js&"
import style0 from "./time-line.vue?vue&type=style&index=0&id=ff6bf78a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6bf78a",
  null
  
)

export default component.exports